import { useEffect } from "react";

import { API_BASE } from "../config/api";

const STORAGE_KEY = "revibrain_ref";

export default function useReferralTracking() {
	useEffect(() => {
		const code = new URLSearchParams(window.location.search).get("ref");

		if (!code) return;

		localStorage.setItem(STORAGE_KEY, code);

		const sentFlag = `revibrain_ref_click_sent_${code}`;

		if (sessionStorage.getItem(sentFlag)) return;

		// Set the flag synchronously (before the request resolves) so a second
		// effect run — e.g. React StrictMode's dev-mode double-invoke — can't
		// race past this check and send a duplicate click.
		sessionStorage.setItem(sentFlag, "1");

		fetch(`${API_BASE}/api/referral/click`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ code }),
			keepalive: true,
		}).catch(() => {});
	}, []);
}
